export default function hasNewFieldsChanges(oldObject, newObject) {
    for (const key of Object.keys(newObject)) {
        const difference = newObject[key] !== oldObject[key] ? newObject[key] : null;
        if (difference !== null) {
            return true;
        }
    }
    return false;
}
